export const normalizeCylinderSerialNumbers = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap((entry) => {
      if (typeof entry === "string") {
        return entry.trim() ? [entry.trim()] : [];
      }

      if (entry && typeof entry === "object") {
        const serial = entry.srNo ?? entry.srno ?? entry.sr_no ?? entry.serialNo ?? entry.serialNumber ?? "";
        return serial ? [String(serial)] : [];
      }

      return [];
    }).filter(Boolean);
  }

  if (typeof value === "string") {
    return value.trim() ? [value.trim()] : [];
  }

  if (value && typeof value === "object") {
    const serial = value.srNo ?? value.srno ?? value.sr_no ?? value.serialNo ?? value.serialNumber ?? "";
    return serial ? [String(serial)] : [];
  }

  return [];
};

export const normalizeCylinderBatchNumbers = (value) => {
  if (Array.isArray(value)) {
    return value.flatMap((entry) => {
      if (typeof entry === "string") {
        return entry.trim() ? [entry.trim()] : [];
      }

      if (entry && typeof entry === "object") {
        const batch = entry.batchNo ?? entry.batch_no ?? entry.batchno ?? "";
        return batch ? [String(batch)] : [];
      }

      return [];
    }).filter(Boolean);
  }

  if (typeof value === "string") {
    return value.trim() ? [value.trim()] : [];
  }

  if (value && typeof value === "object") {
    const batch = value.batchNo ?? value.batch_no ?? value.batchno ?? "";
    return batch ? [String(batch)] : [];
  }

  return [];
};

export const normalizeCylinderOptions = (data) => {
  if (!Array.isArray(data)) {
    return [];
  }

  return data.map((item) => {
    const srNo = item?.srNo ?? item?.srno ?? item?.sr_no ?? "";
    const batchNo = item?.batchNo ?? item?.batch_no ?? item?.batchno ?? "";

    return {
      ...item,
      srNo,
      srno: srNo,
      batchNo,
    };
  });
};
